import service from '@/utils/request'
// 查询询价单
export function inquiryList(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiry/inquiryList',
		data: param
	})
}
//根据ID查询信息
export function inquiryById(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiry/inquiryById',
		data: param
	})
}

// 查询询价单 不分页
export function inquiryListAll() {
	return service.request({
		method: 'POST',
		url: '/app/inquiry/list',
	})
}
// 新增询价单
export function addInquiry(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiry/add',
		data: param
	})
}
// 修改询价单
export function editInquiry(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiry/edit',
		data: param
	})
}

// 批量删除询价单
export function batchDelInquiry(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiry/batchDel',
		data: param
	})
}



// 删除询价单
export function delInquiry(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiry/del',
		data: param
	})
}
// 导出询价单
export function exportInquiry(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiry/export',
		data: param
	})
}
// 获取统计值	采购员
export function getStatistics(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiry/getStatistics',
		data: param
	})
}
// 获取统计值 供应商
export function getStatisticsGys(param) {
	return service.request({
		method: 'POST',
		url: '/app/inquiryUser/getGysStatistics',
		data: param
	})
}
